export const initialState = () => ({
  user: {
    id: '',
    subjectId: '',
    enrollmentDate: '',
    visit1Date: '',
    blocked: false,
    dailySportsActivityWeekStartDate: null,
    knowledgeLevel: {
      key: '',
      name: '',
      level: null,
    },
    patient: {
      patientId: null,
      birthdate: '',
      name: [],
      gender: '',
      telecom: [],
    },
  },
  bloodPressure: {
    component: [],
    status: '',
  },
  weight: {
    valueQuantity: { value: null, unit: '' },
  },
  length: {
    valueQuantity: { value: null },
  },
  BMI: {
    effectiveDateTime: '',
    valueQuantity: {
      code: null,
      value: null,
    },
  },
  LDL: {
    valueQuantity: { value: null, unit: '' },
  },
  LDLInPreferredUnit: {
    valueQuantity: { value: null, unit: '' },
  },
  HbA1c: {
    valueQuantity: { value: null, unit: '' },
  },
  HbA1cInPreferredUnit: {
    valueQuantity: { value: null, unit: '' },
  },
  eGFR: {
    valueQuantity: {
      value: null,
    },
  },
  SDMEncounters: [],
  patientSettings: [],
  outcomeComponents: [],
  outcomeGoals: [],
  behaviourComponents: [],
  behaviourGoals: [],
  targetVersion: null,
  isResetRequired: false,
  heartRate: {
    valueQuantity: { value: null },
  },
  lastCompletedSixMinuteWalkingTest: { distanceWalked: null },
  unsavedChanges: false,
  unsavedChangesMultiple: [],
  hadSecondVascularEventOnStatins: false
});

export default initialState();
